export interface IPreWorkUpTransactionDetails {
    id: number,
    donorCenter: string,
    donorCenterAlias: string,
    donorFirstName: string,
    donorLastName: string,
    donorEmail: string,
    fileName: string,
    labsUploadedDateTime: string,
    completedDate: string,
    requestedDate: string
}
